import { MapContainer, TileLayer, Marker, Circle } from "react-leaflet";
import L from "leaflet";

const pinIcon = L.divIcon({
  className: "",
  html: `<div style="position:relative;width:36px;height:36px;">
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="#FF453A" stroke="#fff" stroke-width="1.2" style="filter:drop-shadow(0 0 10px rgba(255,69,58,0.9));">
      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/>
      <circle cx="12" cy="10" r="3" fill="#fff" stroke="none"/>
    </svg></div>`,
  iconSize: [36, 36],
  iconAnchor: [18, 34],
});

const TARGET = [40.7484, -73.9857];

export default function MapShowcase() {
  return (
    <div data-testid="map-showcase" className="relative rounded-3xl overflow-hidden border border-[#2A3042]">
      <MapContainer
        center={TARGET}
        zoom={15}
        scrollWheelZoom={false}
        dragging={true}
        style={{ height: "420px", width: "100%", zIndex: 0 }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          className="dark-tiles"
        />
        <Circle
          center={TARGET}
          radius={150}
          pathOptions={{ color: "#34C759", fillColor: "#34C759", fillOpacity: 0.08, weight: 1.5, dashArray: "6 6" }}
        />
        <Marker position={TARGET} icon={pinIcon} />
      </MapContainer>
      <div className="absolute bottom-4 left-4 z-[400] rounded-2xl bg-[#090A0F]/80 backdrop-blur-xl border border-white/10 px-5 py-4 max-w-[260px]">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF453A] mb-1">Live demo map</p>
        <p className="text-sm text-[#c9cdd8]">Creators set a secret target and how close players need to get. Real maps, powered by OpenStreetMap.</p>
      </div>
    </div>
  );
}
